import styled from 'styled-components';

export const RightSideColumns = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
